import moment from 'moment';

export default {
  account: {
    user: {
      idToken: null,
      userName: '',
      roles: [],
      id: null,
      hasRole: (role) => false
    }
  },
  rebatesRCTI: {
    items: [],
    listFilters: {
      dateFrom: "",
      dateTo: "",
      statusType: "",
      clientName: ""
    },
    total: 0,
    detail: {},
    invoices: {
      items: [],
      total: 0,
    }

  },
  checklists: [{
    type: 'pre',
    items: []
  }, {
    type: 'post',
    items: []
  }],
  driverRuns: {
    loaded: false,
    items: [],
  },
  searchRuns: {
    loaded: false,
    isComplete: -1,
    dateFrom: moment(new Date()).format('YYYY-MM-DD'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    selectedDriverId: -1,
    selectedTypes: [],
    items: [],
  },
  run: {},
  location: {
    isGeolocationAvailable: false,
    coords: {latitude: 0, longitude: 0}
  },
  driverLocations: {
    loaded: false,
    items: [],
  },
  drivers: {
    loaded: false,
    items: [],
  },
  trucks: {
    loaded: false,
    items: [],
    collectionTypes: [],
  },
  newRun: {
    locations: [],
    run: {timeStart: moment().format('YYYY-MM-DD'), truckId: -1, driverId: -1, locationBaseId: -1, locationDropOffId: -1, isCollectionRun: true},
    saving: false,
  },
  regions: {
    loaded: false,
    items: [],
  },
  unmappedSuburbs: {
    loaded: false,
    items: [],
  },
  users: {
    loaded: false,
    items: [],
    saveError: {
      user: undefined,
      error: '',
    },
    lastSaved: {
      action: '',
      user: undefined,
    }
  },
  roles: {
    loaded: false,
    items: [],
  },
  bdms: {
    loaded: false,
    items: [],
  },
  clients: {
    loaded: false,
    items: [],
    saveError: {
      client: undefined,
      error: '',
    },
    saveInfo: {
      client: {},
      isNew: false,
      saving: false,
      saved: false,
    }
  },
  locations: {
    loaded: false,
    items: [],
    saveError: {
      location: undefined,
      error: '',
    },
    isNew: false,
    saveInfo: {
      client: {},
      isNew: false,
      saving: false,
      saved: false,
    }
  },
  truckData: {
    isFetching: false,
    connected: false,
    weight: {
      currentWeight: 0,
      currentRawWeight: 0,
      connected: false,
    },
    receipt: null,
    context: null,
    location: null,
    lastActivityAt: null,
    errorReason: null,
    truckNumberPlate: null,
  },
  runReceipts: {
    runId: null,
    items: [],
    loading: false,
  },
  apiConfig: {
    companyName: "Sydney Recycling Services",
    styleName: 'srs-prod',
    truckProxyUri: "",
    gst: 0,
  },
  integrations: {
    setting: {},
    companyFiles: {},
  },
  home: {
    collectionHistory: [],
    clientLocations: [],
    clientLocationsDelivery: []
  },
  clientRequests: {
    list: [],
    total: 0
  } 
};